import { Stack } from '@mui/material';
import { LoginLayout } from 'klayowebshared';
import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { AppContext } from '../../common/AppContext';
import { loginRequest } from '../../common/AuthConfig';
import { getAuthClient } from '../../common/auth/authClient';
import { Button } from '../../components/Button';

// NOTE: This view renders OUTSIDE LocaleProvider (it is shown by the MSAL
// UnauthenticatedTemplate / errorComponent, or after a failed Auth0 callback, in index.tsx). It therefore must NOT use
// useLocale/withLocale — it translates via react-i18next's global instance instead.
class NotLoggedInViewBase extends Component<any & WithTranslation, any> {
  static contextType = AppContext;

  onSignIn() {
    // B2C: a fresh login, never a re-auth of the cached (possibly stale) account that just failed.
    const signIn = this.props.msal
      ? this.props.msal.instance.loginRedirect(loginRequest)
      : getAuthClient().loginRedirect();
    signIn.catch((e: any) => {
      console.error(e);
    });
  }

  render() {
    const { t } = this.props;

    return (
      <LoginLayout heading={t('login.welcomeBack')} text={t('login.pleaseLogIn')}>
        <Stack spacing={6}>
          <Button label={t('login.logIn')} variant='filled' onClick={this.onSignIn.bind(this)} />
        </Stack>
      </LoginLayout>
    );
  }
}

export const NotLoggedInView = withTranslation()(NotLoggedInViewBase);
